import Theme from '@/components/Theme/Theme';
import Question from '@/components/Question/Question';

export default class ThemeArray {
    get all(): Theme[] {
        return this._list.slice(0);
    }

    private _list: Theme[] = [];

    constructor(list?: any) {
        this.fill(list);
    }

    public fill(list?: ThemeArray | Theme[] | Set<Theme> | object) {
        let themes!: Theme[];

        if (list && list instanceof ThemeArray) {
            themes = list.all;
        } else if (Array.isArray(list)) {
            themes = list;
        } else if (list instanceof Set) {
            for (const item of list) {
                this.add(item);
            }
        } else if (typeof list === 'object') {
            for (const item in list) {
                // @ts-ignore
                // console.log(list[item]);
                // @ts-ignore
                this.add(list[item]);
            }
        }

        if (themes) {
            for (let i: number = 0; i < themes.length; i++) {
                this.add(themes[i]);
            }
        }
    }

    public refresh(list?: any) {
        this.clear();
        this.fill(list);
    }

    public clear() {
        this._list.splice(0);
    }

    public add(item: any) {
        this._list.push(new Theme(item));
    }

    unique(): Set<Theme> {
        const set: Set<Theme> = new Set<Theme>();
        for (const item of this._list) {
            set.add(item);
        }

        return set;
    }

    get idArray(): number[] {
        return this._list.map(i=> i.id);
    }
}
